import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { CampaignData } from '../types';

interface CampaignState {
  campaignData: CampaignData | null;
  setCampaignData: (data: CampaignData) => void;
  updateCampaignData: (data: Partial<CampaignData>) => void;
  clearCampaignData: () => void;
}

export const useCampaignStore = create<CampaignState>()(
  persist(
    (set) => ({
      campaignData: null,
      setCampaignData: (data) => set({ campaignData: data }),
      updateCampaignData: (data) => set((state) => ({
        campaignData: state.campaignData ? { ...state.campaignData, ...data } : null
      })),
      clearCampaignData: () => set({ campaignData: null })
    }),
    {
      name: 'campaign-store',
      partialize: (state) => ({ campaignData: state.campaignData })
    }
  )
);